import './MukhaFall.css';
import { Link } from "react-router-dom";
import { BookSection } from "../../../components/BookSection";

export const MukhaFall = () => {
  return (
    <div className="mukha-fall-container">
      <div className="fancy-heading">
        <h1>Mukha Fall</h1>
        <p className="sub-heading">Nature's hidden gem, a perfect escape into tranquility.</p>
      </div>
      <div className="description">
      This beautiful waterfall is situated 40 km west of district head quarter on the bank of river Belan in Ghorawal tehsil. Here the water of river belan is falling from a height of about 100 ft. The scenic beauty of the waterfall and its rich natural surrounding compels the tourists to visit the place again and again. A huge number of beautiful rock painting add to the beauty and specialty of the place. Mukha Fall is a breathtaking natural wonder, known for its cascading waters and serene surroundings. A popular destination for tourists and locals alike, this spot offers a perfect blend of adventure and relaxation.
      </div>
      <div className="image-gallery">
        <div className="image-item">
          <img
            src={require('../../../media/tourism/Mukha fall/fall1.jpeg')}
            alt="Mukha Fall 1"
            className="gallery-image"
          />
          {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
        </div>
        <div className="image-item">
          <img
            src={require('../../../media/tourism/Mukha fall/fall2.jpeg')}
            alt="Mukha Fall 2"
            className="gallery-image"
          />
          {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
        </div>
        <div className="image-item">
          <img
            src={require('../../../media/tourism/Mukha fall/fall3.jpeg')}
            alt="Mukha Fall 3"
            className="gallery-image"
          />
          {/* <p className="image-caption">The lush green surroundings of Mukha Fall.</p> */}
        </div>
        <div className="image-item">
          <img
            src={require('../../../media/tourism/Mukha fall/fall4.jpeg')}
            alt="Mukha Fall 4"
            className="gallery-image"
          />
          {/* <p className="image-caption">The tranquil ambiance at sunset.</p> */}
        </div>
        <div className="image-item">
          <img
            src={require('../../../media/tourism/Mukha fall/fall5.jpg')}
            alt="Mukha Fall 5"
            className="gallery-image"
          />
          {/* <p className="image-caption">A panoramic view of Mukha Fall's beauty.</p> */}
        </div>
      </div>

      <BookSection />
    </div>
  );
};
